{
  "heading-1": {
    "fontFamily": "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
    "fontSize": "2.25rem",
    "fontWeight": 800,
    "lineHeight": 1.2,
    "letterSpacing": "-0.0125em"
  },
  "heading-2": {
    "fontFamily": "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
    "fontSize": "1.5rem",
    "fontWeight": 700,
    "lineHeight": 1.3333333,
    "letterSpacing": "0em"
  },
  "heading-3": {
    "fontFamily": "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
    "fontSize": "1.25rem",
    "fontWeight": 600,
    "lineHeight": 1.6,
    "letterSpacing": "0em"
  },
  "heading-4": {
    "fontFamily": "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
    "fontSize": "1rem",
    "fontWeight": 600,
    "lineHeight": 1.5,
    "letterSpacing": "0em"
  },
  "body": {
    "fontFamily": "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
    "fontSize": "1rem",
    "fontWeight": 400,
    "lineHeight": 1.75,
    "letterSpacing": "0em"
  },
  "body-sm": {
    "fontFamily": "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
    "fontSize": "0.875rem",
    "fontWeight": 400,
    "lineHeight": 1.75,
    "letterSpacing": "0em"
  },
  "lead": {
    "fontFamily": "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
    "fontSize": "1.25rem",
    "fontWeight": 400,
    "lineHeight": 1.6,
    "letterSpacing": "0em"
  },
  "caption": {
    "fontFamily": "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
    "fontSize": "0.75rem",
    "fontWeight": 400,
    "lineHeight": 1.5,
    "letterSpacing": "0.025em"
  },
  "code": {
    "fontFamily": "'JetBrains Mono', ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, 'Liberation Mono', monospace",
    "fontSize": "0.875rem",
    "fontWeight": 400,
    "lineHeight": 1.5,
    "letterSpacing": "0em"
  }
}
